import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";

// styles
import { BatchBodyStyled, BatchInnerChildStyled } from "./styles";

// components
import BatchCollectionsList from "./BatchCollectionsList";

// data
const BATCH_MIN_HEIGHT_WHEN_OPEN = 300;

export const BatchBody = ({
    batch,
    batchContentIsOpen,
    batchCollections,
    BatchGridComponent,
    uploadsStatus = "loading"
}) => {
    const [containerHeight, setContainerHeight] = useState(0);
    const innerChildRef = useRef();

    let allUploadIds = [];

    batchCollections.forEach(bc => {
        allUploadIds = [...allUploadIds, ...bc.uploadIds];
    });

    /**
     * If batch is in state of closed always zero
     * leveraging inner child wrapper's scrollHeight to detect height
     * Note: Be careful not o add any spilling margins within the children, could impact calculation.
     * Will recalculate anytime batchContentIsOpen and allUploadIds changes, since we grab uploads on demand.
     */
    useEffect(() => {
        if (batchContentIsOpen) {
            let calculatedHeight = BATCH_MIN_HEIGHT_WHEN_OPEN;

            if (innerChildRef.current && uploadsStatus !== "loading") {
                calculatedHeight = innerChildRef.current.scrollHeight;
            }

            setContainerHeight(calculatedHeight);
        } else {
            setContainerHeight(0);
        }
    }, [batchContentIsOpen, allUploadIds, uploadsStatus]);

    return (
        <BatchBodyStyled containerHeight={containerHeight}>
            <BatchInnerChildStyled ref={innerChildRef}>
                <BatchCollectionsList
                    batch={batch}
                    batchContentIsOpen={batchContentIsOpen}
                    batchCollections={batchCollections}
                    BatchGridComponent={BatchGridComponent}
                />
            </BatchInnerChildStyled>
        </BatchBodyStyled>
    );
};

BatchBody.propTypes = {
    batch: PropTypes.object.isRequired,
    batchContentIsOpen: PropTypes.bool,
    batchCollections: PropTypes.array.isRequired,
    BatchGridComponent: PropTypes.any.isRequired,
    uploadsStatus: PropTypes.string
};
